import { AxiosInstance, AxiosPromise } from 'axios';
import {
  CancelExportReportRequest,
  CancelExportReportResponse,
  ExportReportEndpoints,
  GetExportDetailsRequest,
  GetExportDetailsResponse,
  SearchExportReportsRequest,
  SearchExportReportsResponse,
  StartExportRequest,
  StartExportResponse,
} from './ExportReportServices.types';

export class ExportReportServices implements ExportReportEndpoints {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  start(request: StartExportRequest): AxiosPromise<StartExportResponse> {
    const { reportId } = request.routeParams;
    return this.instance.post(`/reports/${reportId}/exports`, request.body);
  }

  getById(request: GetExportDetailsRequest): AxiosPromise<GetExportDetailsResponse> {
    const { reportId, exportId } = request.routeParams;

    return this.instance.get(`/reports/${reportId}/exports/${exportId}`);
  }

  search(request: SearchExportReportsRequest): AxiosPromise<SearchExportReportsResponse> {
    const { reportId } = request.routeParams;

    return this.instance.get(`/reports/${reportId}/exports`, {
      params: request.queryParams,
    });
  }

  cancel(request: CancelExportReportRequest): AxiosPromise<CancelExportReportResponse> {
    const { reportId, exportId } = request.routeParams;

    return this.instance.delete(`/reports/${reportId}/exports/${exportId}`);
  }
}
